module.exports = __webpack_public_path__ + "static/img/logo.b8644bfc.png";